import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiClient } from "@/config/api";
import { handleApiError } from "@/utils/functions";
import { ReservationTypeMapping } from "./types";

export const getReservationTypeMappings = createAsyncThunk<
  ReservationTypeMapping[],
  void
>("reservation-type-mappings/getAll", async (_, { rejectWithValue }) => {
  try {
    const response = await apiClient.get("reservation-type-mappings");
    return response.data.data;
  } catch (error) {
    return rejectWithValue(
      handleApiError(error, "Get reservation type mappings failed")
    );
  }
});
